// removed by extract-text-webpack-plugin
module.exports = {"component":"ozJm4aWXtNVbzdVsO284a","remove":"_2MEe68BmPY9xdhKx-m5XM9","img":"lpF98vz0UDvLRaGc6BsLc","big":"_3iQFTuKjMIvpSm4f4V2jkF","txt":"_3xdV18WzwwPB_CrmDG589C","span":"_3uWGb5cX6TquKddZAyb8yN","mr0":"_2i-yxE5nXS2ejAve0WaeTq"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionDesignerComponent/AttentionDesignerComponent.scss
 ** module id = 950
 ** module chunks = 0
 **/